import { render, staticRenderFns } from "./FoldableInput.vue?vue&type=template&id=5534cc1c"
import script from "./FoldableInput.vue?vue&type=script&lang=js"
export * from "./FoldableInput.vue?vue&type=script&lang=js"
import style0 from "./FoldableInput.vue?vue&type=style&index=0&id=5534cc1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports